"use client";

import { useTranslations } from "next-intl";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";

export default function BetAdviseTabs() {
  const pathname = usePathname();
  const isPending = pathname.includes("/bets/advises/pending");
  const isResolved = pathname.includes("/bets/advises/resolved");

  const tBets = useTranslations("bets");

  return (
    <nav className="nav nav-tabs border-bottom-0 mx-0 mx-md-2">
      <Link href="/bets/advises/pending" className={`nav-link px-2 py-1 ${isPending ? "btn-primary-selected" : "btn-primary-outline"}`}>
        {tBets('pending', { count: 2 })}
      </Link>
      <Link href="/bets/advises/resolved" className={`nav-link px-2 py-1 ${isResolved ? "btn-primary-selected" : "btn-primary-outline"}`}>
        {tBets('resolved')}
      </Link>
    </nav>
  );
}
